import React, { FC } from 'react';

import { useIntl } from 'react-intl';

import MenuLineItem from 'components/menu-order-wizard/menu-line-item';
import ModifierPrice from 'components/menu-order-wizard/modifier-price';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';
import { curriedModifierMultiplierNameFromIndex } from 'utils/menu/modifiers';

import { MenuOptionStepperIncrementor } from './menu-option-stepper-incrementor';
import { IMenuOptionStepperProps } from './types';

/** @deprecated Use ProductListItem with a NumberInput control instead */
const MenuModifierStepper: FC<IMenuOptionStepperProps> = ({
  calories,
  image,
  imageDescription,
  name,
  index,
  itemOption,
  onChange,
  price,
  max,
}) => {
  const { formatMessage } = useIntl();

  // * Normally this logic is handled in the <Calories /> wrapper
  // * but seeing as MenuLineItem relies on boolean logic to show/hide the details
  // * its imported here so that an explicit falsy value can be provided
  // * (instead of providing a React Element)
  const uiCaloriesAreHidden = useFlag(LaunchDarklyFlag.HIDE_UI_CALORIES);
  const optionsAndModifiersCaloriesIsEnabled = useFlag(
    LaunchDarklyFlag.ENABLE_CALORIES_FOR_OPTIONS_AND_MODIFIERS
  );
  const hideUiCalories = uiCaloriesAreHidden || !optionsAndModifiersCaloriesIsEnabled;

  const modifierMultiplierValsFromIndex = itemOption
    ? curriedModifierMultiplierNameFromIndex(itemOption)
    : (v: number) => v;

  const maxOptions = itemOption?.options?.length ? itemOption?.options?.length - 1 : 0;

  const details = hideUiCalories ? null : calories;

  return (
    <MenuLineItem
      bottomContent={<ModifierPrice price={price} />}
      data-testid={name}
      name={name}
      details={details}
      highlightOnHover={false}
      ignoreLabelClicks
      image={image}
      imageDescription={imageDescription}
      indicator={
        <MenuOptionStepperIncrementor
          aria-label={formatMessage({ id: 'quantityOf' }, { name })}
          name={name}
          data-testId={`item-quantity-${name}`}
          value={index}
          valueDisplayTransformer={modifierMultiplierValsFromIndex}
          onChange={value => onChange(value)}
          min={0}
          max={max ?? maxOptions}
        />
      }
    />
  );
};

export default MenuModifierStepper;
